"use strict";

exports.__esModule = true;
exports.calculateRunningTime = calculateRunningTime;
var _luxon = require("luxon");
function calculateRunningTime(start, end) {
  var interval = _luxon.Interval.fromDateTimes(start, end).toDuration(['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']).toObject();
  if (interval.years !== undefined && interval.years >= 1) {
    return {
      value: interval.years,
      unit: 'year'
    };
  } else if (interval.months !== undefined && interval.months >= 1) {
    return {
      value: interval.months,
      unit: 'month'
    };
  } else if (interval.weeks !== undefined && interval.weeks >= 1) {
    return {
      value: interval.weeks,
      unit: 'week'
    };
  } else if (interval.days !== undefined && interval.days >= 1) {
    return {
      value: interval.days,
      unit: 'day'
    };
  } else if (interval.hours !== undefined && interval.hours >= 1) {
    return {
      value: interval.hours,
      unit: 'hour'
    };
  } else if (interval.minutes !== undefined && interval.minutes >= 1) {
    return {
      value: Math.ceil(interval.minutes),
      unit: 'minute'
    };
  } else {
    return {
      value: interval.seconds ? Math.ceil(interval.seconds) : 0,
      unit: 'second'
    };
  }
}